var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: { title: _vm.$t("addShipmentFromOrder"), large: "", hideFooter: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c("ToEveryone", {
              attrs: {
                selectedOrder: _vm.selectedOrder,
                template: _vm.template,
                onlyOneLabel: "",
                labelNote: _vm.$t("labelForOrderId", {
                  orderId: _vm.selectedOrder.orderId
                }),
                order: _vm.selectedOrder
              },
              on: {
                submitted: function($event) {
                  return _vm.$emit("input", false)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "leftBtn",
                  fn: function() {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { dark: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("input", false)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("close")))]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14c3eadd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c3eadd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderAddShipment.vue
// module id = null
// module chunks = 